export default function toggleBoolean(prev) {
  return !prev;
}
